import { handleAction, handleSubState } from 'uix/actions';
import { persistReducer } from 'uix/persist/redux';
import log from 'uix/logging';
import { size, dict, filterItems, isNil } from 'ldash';
import { setLogStreamData, setLogStreamMode, setLogStream } from './actions';
// 20k lines need 100ms for recalc/rerendering in prod
const MAX_LINES = process.env.NODE_ENV !== 'production' ? 5000 : 20000;
export const meta = [
    handleSubState('logstream', [
        handleAction(setLogStreamData, (logstream, { payload })=>{
            let { lines } = logstream;
            if (payload.lines) {
                if (payload.lines == 'FLUSH') {
                    lines = [];
                } else {
                    lines = [
                        ...lines || [],
                        ...payload.lines
                    ].slice(-MAX_LINES);
                }
            }
            let isDisconnected = lines && lines.slice(-1)[0]?.startsWith('...disconnected');
            return {
                ...logstream,
                lines,
                isDisconnected
            };
        }),
        persistReducer(handleAction(setLogStream, (logstream, { payload })=>({
                ...logstream,
                ...dict(filterItems(payload, (k, v)=>!isNil(v)))
            })), {
            key: 'uix_logstream',
            whitelist: [
                'channel'
            ]
        }),
        handleAction(setLogStreamMode, (logstream, { payload })=>({
                ...logstream,
                mode: payload.mode
            }))
    ], {
        on: false,
        lines: null,
        mode: 'panel',
        channel: 'vls',
        node: 'host',
        limit: 250,
        isDisconnected: false
    })
];
